/* eslint-disable react-hooks/exhaustive-deps */
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext, useEffect, useState } from 'react'
import { Clipboard2HeartFill } from 'react-bootstrap-icons'
import Authentication from '../../../../../libs/api/services/Authentication'
import Patient from '../../../../../libs/api/services/Patient'
import Questionnaire from '../../../../../libs/api/services/Questionnaire'
import QuestionnaireAssignment from '../../../../../libs/api/services/QuestionnaireAssignment'
import TaskEvents from '../../../../../libs/api/services/TaskEvents'
import WorkFlow from '../../../../../libs/api/services/WorkFlow'
import CommonFunctionsContext from '../../../../common/CommonFunctionsProvider'
import QuestionnaireBuilderContext from '../../builder/QuestionnaireBuilderProvider'
import QFormLayout from './Layouts/QFormLayout'
import QWizardLayout from './Layouts/QWizardLayout'
import './QCapture.css'

export default function QCaptureComponentNew({
    cachedDetails,
    QuestionnaireAssignmentId,
    QuestionnaireId,
    mode,
    view
}) {
    const { SetQuestionnaireComponents, SetAnswers } = useContext(QuestionnaireBuilderContext)
    const [state, setState] = useState({
        loading: true,
        error: undefined,
        formData: [],
        activeSubsections: [],
        available: true
    })
    const { showError } = useContext(CommonFunctionsContext)

    const _getLayoutAxis = (component, axis) => {
        try {
            const layoutValue = component?.resource?.properties?.find(p => p.property === 'Layout')?.values
            if (!layoutValue) return Number.MAX_SAFE_INTEGER
            const parsed = JSON.parse(layoutValue)
            const value = parsed?.[axis]
            return Number.isFinite(Number(value)) ? Number(value) : Number.MAX_SAFE_INTEGER
        } catch (e) {
            return Number.MAX_SAFE_INTEGER
        }
    }

    const _sortComponents = (components) => [...(components || [])].sort((a, b) => {
        const ay = _getLayoutAxis(a, 'y')
        const by = _getLayoutAxis(b, 'y')
        if (ay !== by) return ay - by
        const ax = _getLayoutAxis(a, 'x')
        const bx = _getLayoutAxis(b, 'x')
        if (ax !== bx) return ax - bx
        const ao = Number.isFinite(Number(a?.resource?.order)) ? Number(a.resource.order) : Number.MAX_SAFE_INTEGER
        const bo = Number.isFinite(Number(b?.resource?.order)) ? Number(b.resource.order) : Number.MAX_SAFE_INTEGER
        return ao - bo
    })

    const _sortSections = (sections) => [...(sections || [])].sort((a, b) => {
        const ao = Number.isFinite(Number(a?.resource?.resource?.order)) ? Number(a.resource.resource.order) : Number.MAX_SAFE_INTEGER
        const bo = Number.isFinite(Number(b?.resource?.resource?.order)) ? Number(b.resource.resource.order) : Number.MAX_SAFE_INTEGER
        return ao - bo
    })

    // The helpers below intentionally close over the current render state; this load effect runs once per mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        const _load = async () => {
            // Trigger Opend Event
            if (cachedDetails && !Object.keys(cachedDetails.questionnaire.resource).includes('resource'))
                return setState({ available: false })
            await _handleOnOpen()
            // mode: Discover 
            const activeQuestionnaireAssignment = cachedDetails ? cachedDetails : await QuestionnaireAssignment.GetQuestionnairesAssignmentDetails(this.props.QuestionnaireAssignmentId).catch((e) => this.setState({ error: 'Questionnaire Currently Unavailable' }))
            const options = cachedDetails ? cachedDetails.questionnaire.resource.resource.options : await Questionnaire.GetOptions(this.props.QuestionnaireId)
            const questionnaire = cachedDetails ? cachedDetails.questionnaire.resource.resource : await Questionnaire.GetQuestionnaire(this.props.QuestionnaireId)
            SetAnswers(activeQuestionnaireAssignment.responses)
            var _formData = []
            var _section_idx = 0
            for (const section of _sortSections(questionnaire.sections)) {
                for (const component of _sortComponents(section.components)) {
                    var _required = false
                    try {
                        const required = component.properties.find(p => p.property === 'Required').values
                        _required = JSON.parse(required)
                    } catch (e) { }

                    _formData.push({
                        componentId: component.id,
                        section: _section_idx,
                        validate: _required,
                        valid: false,
                        value: ''
                    })
                }
                _section_idx++
            }

            setState({
                ...state,
                details: {
                    assignment: activeQuestionnaireAssignment,
                    // options: cachedDetails.questionnaire.options,
                    questionnaire: cachedDetails.questionnaire,
                    options: options && [...options,]
                    // cachedDetails.questionnaire.resource.resource.type === "Form" ? [
                    //     {
                    //         name: 'SHOW_TITLE',
                    //         value: JSON.stringify({
                    //             type: 'None'
                    //         })
                    //     }, {
                    //         name: 'SHOW_SECTION_TITLE',
                    //         value: JSON.stringify({
                    //             type: 'Hide'
                    //         })
                    //     }
                    // ] : []
                    // ]
                },
                formData: _formData,
                activeSubsections: _loadSubsectionState(),
                loading: false
            })
        }
        const _loadSubsectionState = () => {
            var _activeSubsections = state.activeSubsections
            let cachedComponents = []
            for (const section of _sortSections(cachedDetails.questionnaire.resource.resource.sections)) {
                for (const component of _sortComponents(section.components)) {
                    var _options = undefined
                    cachedComponents.push(component)
                    try {
                        const opts = component.properties.find(p => p.property === 'Options').values
                        _options = JSON.parse(opts)
                        const _subsection = _options.find(o => o.subsection)

                        try {
                            //  If array
                            const _answers = JSON.parse(cachedDetails.questionnaire.resource.resource.responses.find(o => o.answerType.id === component.id).answer)
                            for (const _a of _answers) {
                                if (_a.active)
                                    if (_subsection.subsection) {
                                        if (_subsection.option === _a.option)
                                            _activeSubsections[component.id] = _subsection.subsection
                                    }
                            }
                        } catch (e) {
                        }

                        // Need to also compare values selected
                        if (_subsection.subsection) {
                            if (_subsection.option === cachedDetails.questionnaire.resource.resource.responses.find(o => o.answerType.id === component.id).answer)
                                _activeSubsections[component.id] = _subsection.subsection
                        }
                    } catch (e) {
                        // console.error('_loadSubsectionState',e)
                    }
                }
            }
            SetQuestionnaireComponents(cachedComponents)
            return _activeSubsections
        }
        _load()
    }, [])

    const _handleOnOpen = async () => await _handleTriggerStartEvent()

    const _onSetData = (componentId, value, update) => {
        // SetResponse()
        // var _formData = state.formData
        // // Find component types for dynamic sub sections
        // try {
        //     // Find component types for dynamic sub sections
        //     try {
        //         const _subSection = _findComponentOptionProperty(componentId, value, 'subsection')

        //         if (_subSection !== 'Arr') {
        //             if (_subSection)
        //                 _toggleActiveSection(componentId, _subSection)
        //             else
        //                 _toggleActiveSection(componentId, undefined)
        //         }
        //     } catch (e) { }

        //     try {
        //         var el = _formData.find(c => c.componentId === componentId)
        //         el.value = value
        //         if (value && value !== "") {
        //             el.valid = true
        //         } else {
        //             el.valid = false
        //         }
        //     } catch (e) { }

        //     if (update)
        //         Questionnaire
        //             .QuestionnaireResponse(this.state.details.assignment.id, {
        //                 answerType: {
        //                     id: componentId
        //                 },
        //                 answer: value
        //             })
        //             .then((r) => {
        //             })
        // } catch (e) { }
        // setState({ ...state, formData: _formData })
    }

    /*
    - Module: Questionnaire
    - Trigger: Completed
    - payload: {}
    - questionnaire_complete
*/
    const _handleTriggerStartEvent = async () => mode !== 'Discover' && await WorkFlow
        .TriggerAutomation('Questionnaire', 'QUESIONNAIRE_STARTED', {
            userId: Authentication.UserId() ? Authentication.UserId() : '',
            facility: Authentication.getFacility() ? Authentication.getFacility() : '',
            questionnaire: cachedDetails.questionnaire.resource.resource.id,
            assignment: cachedDetails.id,
            patient: JSON.stringify(cachedDetails.assignedTo.id)
        }).catch((e) => {
            // Logging result to system logs in API
        })


    const _handleTriggerPostEvent = async () => {
        if (mode === 'Discover') return
        try {
            await WorkFlow
                .TriggerAutomation('Questionnaire', 'QUESIONNAIRE_COMPLETE', {
                    userId: Authentication.UserId() ? Authentication.UserId() : '',
                    facility: Authentication.getFacility() ? Authentication.getFacility() : '',
                    questionnaire: cachedDetails && cachedDetails.questionnaire.resource.resource ? cachedDetails.questionnaire.resource.resource.id : QuestionnaireId,
                    assignment: cachedDetails ? cachedDetails.id : QuestionnaireAssignmentId,
                    patient: JSON.stringify(state.details.assignment.assignedTo.id)
                }).catch((e) => {
                    // Logging result to system logs in API
                })
        } catch (e) {
            // alert(e)
            console.error(e)
        }
        try {
            const ON_COMPLETE_TRIGGER_EVENT_EVENT = this.state.details.options.find(r => r.name === 'ON_COMPLETE_TRIGGER_EVENT_EVENT');
            if (ON_COMPLETE_TRIGGER_EVENT_EVENT) {
                const _ON_COMPLETE_TRIGGER_EVENT_EVENT_PARSED = JSON.parse(ON_COMPLETE_TRIGGER_EVENT_EVENT.value)
                var tasks = await Patient
                    .TriggerUserEvent(_ON_COMPLETE_TRIGGER_EVENT_EVENT_PARSED.id, this.state.details.assignment.assignedTo.id)
                for (const task of tasks) {
                    try {
                        //Trigger each task by id task.id
                        await TaskEvents.TriggerTaskUser(task.id, this.state.details.assignment.assignedTo.id, {}, Authentication.getFacility())
                    } catch (e) { }
                }
            }
        } catch (e) {
        }
    }

    const _handleOnComplete = async () => {
        if (mode === 'Discover') return
        await QuestionnaireAssignment
            .CompleteQuestionnaire(
                state.details.assignment.id)
        await _handleTriggerPostEvent()
        if (state.details.assignment.questionnaire.resource.resource.name === "Login - Registration Form") {
            try {
                await Authentication.onboardUser({
                    userId: state.details.assignment.assignedTo.id,
                    accessKey: "^&jjj555&&6%^3#2hs8844858_0998&4@"
                })
            }
            catch (e) {
                showError(e)
                return
            }
            // Redirect to Dashboard
            window.location = '/facilities'

            return
        }
        window.location = '/Dashboard'
    }
    // if (state.loading) return <LoaderComponent />
    if (!state.available) return <div className={`d-flex flex-grow-1 h-100 justify-content-center align-items-center `} style={{ left: '0px', top: '0px', right: '0px', bottom: '0px', zIndex: 1000 }}>
        <div className='text-center'>
            <Clipboard2HeartFill size={75} />
            <div>
                Unfortunately, this item is no longer available
            </div>
        </div>
    </div>
    if (state.error) return <div>{state.error}</div>
    return (
        <>
            <div className={`d-flex justify-content-center align-items-center position-absolute bg-primary-container ${state.loading ? 'show-loading' : 'hide-loading'}`} style={{ left: '0px', top: '0px', right: '0px', bottom: '0px', zIndex: 1000 }}>
                <div className='text-center' style={{ position: 'absolute' }}>
                    <Clipboard2HeartFill size={75} />
                    <div>
                        <FontAwesomeIcon className='me-2' size='2x' icon={faSpinner} spinPulse />
                        Getting Questionnaire Ready
                    </div>
                </div>
            </div>
            {
                state.details && state.details.questionnaire && (
                    mode === "Discover" ?
                        <QFormLayout
                            mode={mode}
                            view={view}
                            details={state.details}
                            cachedDetails={cachedDetails}
                            formData={state.formData}
                            onSetData={(componentId, value, update) => _onSetData(componentId, value, update)}
                            onComplete={() => _handleOnComplete()}
                            activeSubsections={state.activeSubsections}
                        />
                        :
                        state.details.questionnaire.resource.resource.layout &&
                            state.details.questionnaire.resource.resource.layout.layout &&
                            state.details.questionnaire.resource.resource.layout.layout === "Wizard Layout"
                            ? <QWizardLayout
                                mode={mode}
                                view={view}
                                details={state.details}
                                cachedDetails={cachedDetails}
                                formData={state.formData}
                                onSetData={(componentId, value, update) => _onSetData(componentId, value, update)}
                                onComplete={() => _handleOnComplete()}
                                activeSubsections={state.activeSubsections}
                            />
                            :
                            <QFormLayout
                                mode={mode}
                                view={view}
                                details={state.details}
                                cachedDetails={cachedDetails}
                                formData={state.formData}
                                onSetData={(componentId, value, update) => _onSetData(componentId, value, update)}
                                onComplete={() => _handleOnComplete()}
                                activeSubsections={state.activeSubsections}
                            />)
            }
        </>
    )
}
